import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { TrendingUp, Eye, Users, FileText, Flame } from "lucide-react";

// Public, aggregate-only recruiting momentum for a player profile.
// Never exposes who viewed — counts only.
export default function RecruitingMomentum({ playerId }) {
  const [m, setM] = useState(null);
  useEffect(() => {
    if (!playerId) return;
    api.get(`/players/${playerId}/momentum`).then(({ data }) => setM(data)).catch(() => setM(null));
  }, [playerId]);

  if (!m || !m.has_activity) return null;

  const rows = [
    { icon: Eye, label: "Recruiter Views This Month", value: m.recruiter_views_30d, show: m.recruiter_views_30d > 0, up: true },
    { icon: Users, label: "New Watch Lists (30d)", value: m.watchlists_added_30d, show: m.watchlists_added_30d > 0 },
    { icon: FileText, label: "Portfolio Views (30d)", value: m.portfolio_views_30d, show: m.portfolio_views_30d > 0 },
    { icon: Eye, label: "Profile Views This Month", value: m.profile_views_30d, show: m.profile_views_30d > 0 },
  ].filter((r) => r.show);

  return (
    <div className="border border-slate-200 rounded-sm p-6" data-testid="recruiting-momentum">
      <div className="flex items-center gap-2 label-overline text-[#E63946]"><Flame className="w-4 h-4" /> Recruiting Momentum</div>
      {m.trending_up && (
        <div className="mt-3 flex items-center gap-1.5 text-emerald-600 text-sm font-semibold" data-testid="momentum-trending-up">
          <TrendingUp className="w-4 h-4" /> Recruiting interest trending up
        </div>
      )}
      <div className="mt-3 space-y-2">
        {rows.map((r, i) => (
          <div key={i} className="flex items-center gap-2 text-sm text-slate-700">
            <r.icon className="w-4 h-4 text-slate-400 shrink-0" />
            <span className="font-data text-[#0A192F] text-base">{r.up ? "↑ " : ""}{r.value}</span>
            <span className="text-slate-500">{r.label}</span>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-slate-400 mt-3">Aggregate engagement only — individual viewer identities are never shown.</p>
    </div>
  );
}
